import { render, staticRenderFns } from "./a-product-price.vue?vue&type=template&id=5a01b8a3&"
import script from "./a-product-price.vue?vue&type=script&lang=js&"
export * from "./a-product-price.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports